<template>
  <el-dialog  title="联动报警设置" :visible.sync="showBlock" :show-close="true"  width="1200px" :before-close="closedBtn"  :close-on-click-modal="false">
    <div class="root">
      <div class="top">
        <div class="top-name" v-show="operator == 'setup'">
          项目名称
        </div>
        <div style="width: 326px;margin-right: 12px;">
          <el-input type="" style="width: 326px;border-radius: 6px;" v-show="operator == 'setup'" maxlength="15"></el-input>
          <h3 v-show="operator == 'query'" style="font-size: 16px;font-weight: bold;">项目名xxx</h3>
        </div>
        <div class="top-edit" v-show="operator == 'setup'">
          <img src="../../../../../assets/custom-image/project/linkage-edit.svg" alt="" srcset="">
        </div>
        <div v-show="operator == 'setup'">
          <el-button class="btn" @click="police">选择报警设备</el-button>
        </div>
        <!-- <div>
          首次新增联动默认一级，根据需要选择对应的关联设备
        </div> -->
      </div>
      <div class="buttom">
        <div class="buttom-line"></div>
        
        <template v-for="(item,index) in devList"> 
        
        <!-- 第一级 -->
        <div class="box oneBox" :key="item.id" style="margin-top: 32px;margin-left: 36px;">
          <div class="oneBoxRadis"></div>
          <div class="address">
            <div class="title">
              {{ item.spaceAddress }}
            </div>
            <div class="toolp" v-if="operator == 'setup'">
              <!-- <img src="../../../../assets/custom-image/project/linkage-add.svg" @click="operatorShow(item,'children')" alt="">
              <img src="../../../../assets/custom-image/project/linkage-edit.svg" @click="operatorShow(item,'edit')" alt="" srcset="">
              <img src="../../../../assets/custom-image/project/linkage-del.svg" @click="del(item)" alt="" srcset=""> -->
            </div>
          </div>
          <div class="text">
            <div class="deviceImg">
              <el-image
                style="width: 100%; height: 100%;border-radius: 100%;"
                :src="item.img"></el-image>
            </div>
            <div class="device">
              <div class="device-title">{{ item.deviceName }}</div>
              <div class="device-deail">
                <span>序列号/IMEI:</span>
                <span>{{ item.serialNo }}</span>
              </div>
              <div class="device-deail">
                <span>报警名称:</span>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 第二级别 -->
        <template v-for="(itemTwo,index) in item.children || []">

          <div class="box boxLine" :key="itemTwo.id" style="margin-top: 15px;margin-left: 73px;">
            <div class="boxLineRadis"></div>
            <div class="address">
              <div class="title">
                {{ itemTwo.spaceAddress }}
              </div>
              <div class="toolp" v-if="operator == 'setup'">
                <!-- <img src="../../../../assets/custom-image/project/linkage-add.svg" @click="operatorShow(itemTwo,'children',2)" alt="">
              <img src="../../../../assets/custom-image/project/linkage-edit.svg" @click="operatorShow(itemTwo,'edit')" alt="" srcset="">
                <img src="../../../../assets/custom-image/project/linkage-del.svg" @click="del(itemTwo)" alt="" srcset=""> -->
              </div>
            </div>
            <div class="text">
              <div class="deviceImg">
                <el-image
                  style="width: 100%; height: 100%;border-radius: 100%;"
                  :src="itemTwo.img"></el-image>
              </div>
              <div class="device">
                <div class="device-title">{{ itemTwo.name }}</div>
                <div class="device-deail">
                  <span>序列号/IMEI:</span>
                  <span>{{ itemTwo.serialNo }}</span>
                </div>
                <div class="device-deail">
                  <span>动作名称:</span>
                  <span>{{ itemTwo.cmdName }}</span>
                </div>
              </div>
            </div>
          </div> 


          <!-- 第三级别 后期 优化 临时更改 -->
          <template v-for="(itemThree,index) in itemTwo.children || []">
            
            <div class="box boxThree" :key="itemTwo.id" style="margin-top: 15px;margin-left: 119px;">
              <div class="boxThreeRadis"></div>
              <div class="address">
                <div class="title">
                  {{ itemThree.spaceAddress }}
                </div>
                <div class="toolp" v-if="operator == 'setup'">
                  <!-- <img src="../../../../assets/custom-image/project/linkage-add.svg" @click="operatorShow(itemThree,'children')" alt="">
                  <img src="../../../../assets/custom-image/project/linkage-del.svg" @click="del(itemThree)" alt="" srcset=""> -->
                </div>
              </div>
              <div class="text">
                <div class="deviceImg">
                  <el-image
                    style="width: 100%; height: 100%;border-radius: 100%;"
                    :src="itemThree.img"></el-image>
                </div>
                <div class="device">
                  <div class="device-title">{{ itemThree.name }}</div>
                  <div class="device-deail">
                    <span>序列号/IMEI:</span>
                    <span>{{ itemThree.serialNo }}</span>
                  </div>
                  <div class="device-deail">
                    <span>动作名称:</span>
                    <span>{{ itemThree.cmdName }}</span>
                  </div>
                </div>
              </div>
            </div> 

          </template>

        </template>

      </template>

      </div>
    </div>
    <block-linkage-select ref="blockLinkageSelect"></block-linkage-select>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showBlock = false">取 消</el-button>
      <el-button type="primary" @click="closedBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import blockLinkageSelect from './block_linkage_select.vue'

export default {
  components:{
    blockLinkageSelect
  },
  data() {
    return {
      showBlock:false,
      devList:[],
      operator:'',
      subtabulation:{}
    };
  },
  mounted(){
   this.init();
  },
  methods: {
    open(item,subtabulation){
      this.subtabulation = subtabulation;
      this.subtabulation.getSubList(this);
      this.operator = item.operator;
      this.showBlock = true;
    },
    init(){
    },
    police(item){
      this.$refs.blockLinkageSelect.open(item)
    },
    closedBtn(){
      this.showBlock = false;
    },
    del(item){
      // this.$confirm('您确定要移除选中的数据?, 是否继续?', '删除', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(async () => {
      //     let param = {
      //       id:item.projectSubId,
      //       projectId: this.edits.id
      //     }
      //     console.log("删除",param)
      //   })
    }
  }
}
</script>

<style lang="scss" scoped>
   ::v-deep .el-dialog__header{
    // width: 92%;
    height: 23px;
    background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
  .oneBoxRadis{
    width: 5px;
    border: 0.5px solid rgb(200, 200, 200);
    height: 5px;
    border-radius: 100%;
    position: absolute;
    bottom: 47%;
    z-index: 99;
    left: -9.6%;
    background: #fff;
  }
  .oneBox::after{
    content: "";
    border: 0.5px solid rgb(200, 200, 200);
    position: absolute;
    top: 50%;
    width: 33px;
    left: -8%;
  }
  // .oneBox::before{
  //   content: "";
  //   width: 5px;
  //   border: 0.5px solid rgb(200, 200, 200);
  //   height: 5px;
  //   border-radius: 100%;
  //   position: absolute;
  //   bottom: 47%;
  //   left: -9.6%;
  // }

  .boxLineRadis{
    width: 5px;
    border: 0.5px solid rgb(200, 200, 200);
    height: 5px;
    border-radius: 100%;
    position: absolute;
    z-index: 99;
    bottom: 46.8%;
    left: -18.1%;
    background-color: #fff;
  }

  .boxLine::after{
    content: "";
    opacity: 0.8;
    border: 0.5px dashed rgba(0,149,255,1);
    position: absolute;
    top: 50%;
    width: 68px;
    left: -16%;
  }

  .buttom-line::after{
    content: "";
    width: 15px;
    background-color: #fff;
    position: absolute;
    height: 70px;
    left: -7px;
    bottom: 0;
  }
  .buttom-line::before{
    content: "";
    width: 15px;
    background-color: #fff;
    position: absolute;
    height: 107px;
    left: -7px;
  }

  // .boxLine::before{
  //   content: "";
  //   width: 5px;
  //   border: 0.5px solid rgb(200, 200, 200);
  //   height: 5px;
  //   border-radius: 100%;
  //   position: absolute;
  //   bottom: 46.9%;
  //   left: -17.8%;
  // }

  .root{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .top-name{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #56585C;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 400;
    margin-right: 12px;
  }

  .top{
    display: flex;
    align-items: center;
  }

  .top-edit{
    width: 32px;
    height: 31px;
    border: 1px solid rgba(220,221,224,1);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 40px;
  }

  .btn{
    background-image: linear-gradient(270deg, #4AA7FF 0%, #246EFF 100%);
    border-radius: 6px;
    color: #fff;
    width: 120px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 400;
  }

  ::v-deep .el-input__inner{
    height: 32px !important;
  }

  .buttom-line{
    position: absolute;
    left: -3px;
    z-index: 90;
    height: 100%;
    border-left:0.5px solid rgba(200,200,200,1);
  }

  .buttom{
    position: relative;
    width: 58%;
    box-sizing: border-box;
    .box{
      position: relative;
      box-sizing: border-box;
      padding: 0 15px 0 15px;
      width: 438px;
      height: 150px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(226,226,226,1);
      border-radius: 10px;
      margin-top: 32px;
    }

    .address{
      // height: 21%;
      box-sizing: border-box;
      width: 100%;
      display: inline-block;
      padding-top: 15px;
      padding-bottom: 6px;
      // background-color: #4AA7FF;
      .title{
        font-family: PingFangSC-Semibold;
        font-size: 15px;
        color: #232428;
        letter-spacing: 0;
        line-height: 15px;
        font-weight: 600;
        float: left;
      }
      .toolp{
        float: right;
        img:nth-child(1){
          margin-right: 20px;
        }
      }
    }
    .text{
      // background-color: #246EFF;
      height: 70%;
      padding-bottom: 21px;
      .deviceImg{
        width: 85px;
        height: 85px;
        float: left;
        // background-color: #246EFF;
      }
      .device{
        height: 100%;
        width: calc(100% - 105px);
        float: right;
      }
      .device-title{
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #333333;
        letter-spacing: 0;
        line-height: 15px;
        font-weight: 400;
      }
      .device-deail{
        margin-top: 14px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 400;
        span:nth-child(1){
          margin-right: 7px;
        }
      }
    }
  }

  
</style>